import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

// Firebase
import { db } from '../config/firebase-config';
import { collection, getDocs, getDoc, addDoc, updateDoc, doc, setDoc, deleteDoc, query, where, onSnapshot, orderBy, startAfter, limit } from 'firebase/firestore';

import mixpanel from 'mixpanel-browser';

// Redux
import { connect } from 'react-redux';

// Actions
import { setPage, add_To_Recent_History, toggleAuthModal } from '../actions/navActions';

// Layout Wrapper
import Layout from '../components/layout/Layout';
import { setCategories, set_ShowBottomSpinner } from '../actions/categoryActions';
import GroupBlock from '../components/Groups/GroupBlock';
import Spinner from '../components/common/Spinner';
import replaceHyphenWithSpace from '../utils/reusable_functions/replace_Hyphens_With_Space';
import { CATEGORY_LIST } from '../utils/constant_variables/CATEGORIES_LIST';

// Icons
import LocalMallOutlinedIcon from '@material-ui/icons/LocalMallOutlined';
import { HorizontalNav } from '../components/common/HorizontalNav';

const CategoriesPage = ({ 
    setPage, 
    add_To_Recent_History,
    match, 
    category: {
        categories, 
        no_more_categories,
        loading,
        show_bottom_spinner,
        last_page_doc
    },
    auth,
    nav: {
        website,
        website_loading
    },
    setCategories,
    set_ShowBottomSpinner
}) => {

    // State variable to track if Mixpanel event has been sent
    const [sentMixpanel, setSentMixpanel] = useState(false);

    // Window width
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // -- Inifite scroll --

    // Temporarily disable to load more function to avoid duplicate fetch requests
    const [canLoadMore, setCanLoadMore] = useState(true);
    // Scroll direction - for displaying top nav bar
    const [scrollDirection, setScrollDirection] = useState("up");
    const [oldScrollY, setOldScrollY] = useState(window.scrollY);

    // -- END: Inifite scroll --

    const [categoriesList, setCategoriesList] = useState([]);

    // Get the current URL and extract the "redirect" parameter
    const url_filter = (window.location.href);
    const url = new URL(url_filter);
    const hostname = window.location.hostname;
    const search_tag = match.params.search_tag?.toLowerCase();

    // Determine window size breakpoints
    const isMobile = windowWidth <= 769;
    const isTablet = windowWidth <= 1000;

    // Listen for window resize event and update window width state
    useEffect(() => {

        // Set the current page to 'likes'
        setPage('categories');
        add_To_Recent_History(url.pathname);  // current url

        // Add event listener for window resize
        window.addEventListener('resize', () => handleWindowSizeChange());

        // Clean up by removing event listener on component unmount
        return () => window.removeEventListener('resize', () => handleWindowSizeChange());
    }, []);

    // Update window width state on window resize
    const handleWindowSizeChange = () => {
        setWindowWidth(window.innerWidth);
    };

    // -- Get initial categories list --

    useEffect(() => {
        setCategories(CATEGORY_LIST?.filter(item => item.parent_id === null));

    }, []);

    // -- END: Get initial categories list --

    useEffect(() => {

        renderCategoriesList();

    }, [ categories, loading, canLoadMore ]);

    // Handle top nav bar display
    const handleScroll = (e) => {
        const { offsetHeight, scrollTop, scrollHeight } = e.target

        const newScrollY = offsetHeight + scrollTop;

        // --- Handle top nav bar display
        if(isMobile) {
            if(oldScrollY < newScrollY){

                // scrolling down - hide top nav
                setScrollDirection("down");
    
                if(document.getElementById('feed-header') !== null) {
                    document.getElementById('feed-header').classList.remove("active");
                }
                
            } else {
    
                // scrolling up - show top nav
                setScrollDirection("up");
    
                if(document.getElementById('feed-header') !== null) {
                    document.getElementById('feed-header').classList.add("active");
                }
            }
        }
        // --- END Handle top nav bar display

        // update the scroll position for future comparison
        setOldScrollY(newScrollY)

        // Check if the user has scrolled to the bottom of the content and conditions for loading more notifications are met
        if (newScrollY >= scrollHeight - 1 && !show_bottom_spinner && !no_more_categories && categories.length > 0 && canLoadMore) {
            console.log('scrolling');
            // loadMore();
        }
    }

    // Function to load more paginated notifications
    const loadMore = async () => {
        console.log('Loading more categories');

        try {
            // Temporarily disable to load more function to avoid duplicate fetch requests
            setCanLoadMore(false);
            // Show spinner
            set_ShowBottomSpinner(true);

            // TODO: Add pagination to this page
            return; 
        } catch (error) {
            console.log("ERROR loading more", error);
        } finally {
            // Re-enable the load more capabilty
            setCanLoadMore(true);
        }

    }

    // Handles Mixpanel tracking
    const handleMixpanel = () => {
        mixpanel.init(process.env.REACT_APP_MIXPANEL_ID);

        // Track event
        mixpanel.track("Categories Page View");
    }

    // Checks if the environment is production and Mixpanel tracking hasn't been sent
    if(process.env.NODE_ENV === 'production' && !sentMixpanel && !hostname.includes('xbuysell')) {
        // Call Mixpanel tracking function
        handleMixpanel();
        // Set Mixpanel event as sent
        setSentMixpanel(true);
    }

    const renderCategoriesList = async () => {
        setCategoriesList([]);

        if(loading) {
            setCategoriesList([(
                <div className="no-rides">
                    <Spinner />
                </div>
            )])
        }
        else { 
            if(categories.length > 0) {
                categories.map(category_doc => {
                    setCategoriesList(categoriesList => [...categoriesList, (
                        <div onClick={() => window.location.href = `/category/${category_doc.url_handle}`} className={`notification`} style={{height: '100px'}}>
                            <div className="categoryBlock_img">
                                <img style={{height: '100%'}} src={category_doc.img} />
                            </div>

                            <div className='categoryBlock_content'>
                                <h1>{category_doc.name}</h1>
                                <div style={{height: '100%', display: 'flex', alignItems: 'center', paddingRight: '10px'}}>
                                    <div className='see_more_btn icon_18' style={{zIndex: 10}}>
                                        {/* Icon */}
                                        <LocalMallOutlinedIcon />
                                        <span style={{width: '5px'}}></span>
                                        Browse 
                                    </div>
                                </div>
                            </div>
                        </div>
                    )])
                }) 
            } else {
                setCategoriesList(userList => [...userList, (
                    <div className="no-rides">
                        <h1>No categories found</h1>
                    </div>
                )])
                
            }
        } 
    }

    return (
        <Fragment>
            <Layout handleScroll={handleScroll} page="categories">
                <div style={{margin: '13px 0 5px'}}>
                    <HorizontalNav>
                        {CATEGORY_LIST.filter(item => item.parent_id === null).map(item => {
                            return (
                                <div
                                    onClick={() => {
                                        window.location.href = `/category/${item.url_handle}`;
                                    }}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        padding: '0 16px',
                                        boxSizing: 'border-box',
                                        height: '33px',
                                        minWidth: 'fit-content',
                                        borderRadius: '9999px',
                                        backgroundColor: '#f3f4f6',
                                        color: '#4b5563',
                                        fontSize: '14px',
                                        fontWeight: 600,
                                        fontFamily: 'sans-serif',
                                        transition: 'background-color 0.15s ease-in-out',
                                        cursor: 'pointer',
                                        marginLeft: '5px'
                                    }}
                                >
                                    {item.name}
                                </div>
                            )
                        })}
                        
                    </HorizontalNav>
                </div>

                {/* spacer */}
                <div style={{height: '5px'}}></div>
                {categoriesList}

                {/* Render a spinner at the bottom if there are more notifications to load */}
                {show_bottom_spinner && !no_more_categories && !loading && <Spinner />}

                {/* Display a message when there are no more notifications */}
                <div className="no-rides" style={{minHeight: '400px', justifyContent: 'start', paddingTop: '50px'}}>{(no_more_categories && categories.length !== 0) && "You've reached the end."}</div>
            </Layout>
        </Fragment>
    )
}

CategoriesPage.propTypes = {
    auth: PropTypes.object.isRequired,
    nav: PropTypes.object.isRequired,
    category: PropTypes.object.isRequired, // Object prop representing the group state
    setPage: PropTypes.func.isRequired, // Function prop to set the current page in the navigation
    add_To_Recent_History: PropTypes.func.isRequired,
    setCategories: PropTypes.func.isRequired,
    set_ShowBottomSpinner: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({

    // Mapping the states from the Redux store to the below props
    category: state.category,
    auth: state.auth,
    nav: state.nav
});

export default connect(mapStateToProps, { 

    // Connecting actions to the component
    setPage, 
    add_To_Recent_History,
    setCategories,
    set_ShowBottomSpinner
})(CategoriesPage);
